<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <div class="text-left">
          <h4>Vehiculo - Auto</h4>
        </div>
        <!-- TIPO DE VEHICULO -->
        <div v-if="isFieldVisible('car_type_id')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="carType" class="form-label text-left">{{ getFieldDescription('car_type_id') }}</label>
            <SelectCarsTypes
            :data="carType"
            v-bind:selectedTypesCar="selectedTypesCars"
            v-on:update:selectedTypesCar="selectedTypesCars = $event"
            @change="emitFieldChanged('carType')"
            required="required"
            >
            </SelectCarsTypes>
          </div>
        </div>
        <!-- MARCA DE VEHICULO -->
        <div v-if="isFieldVisible('car_type_id')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="carBrand" class="form-label text-left">Marca de Vehiculo</label>
            <SelectCarsBrands
            :data="carBrand" 
            v-bind:selectedBrandsCar="selectedBrandsCars" 
            v-on:update:selectedBrandsCar="selectedBrandsCars = $event"
            @change="emitFieldChanged('carBrand')"
            required
            >
            </SelectCarsBrands>
            
          </div>
        </div>
        <!-- MODELO DE VEHICULO -->
        <div v-if="isFieldVisible('car_model_id')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="carMdel" class="form-label text-left">Modelo de Vehiculo</label>
            <SelectCarsModels
            :data="carMdel" 
            v-bind:selectedModelsCar="selectedModelsCars" 
            v-on:update:selectedModelsCar="selectedModelsCars = $event"
            @change="emitFieldChanged('carMdel')"
            required="required"
            >
            </SelectCarsModels>
          </div>
        </div>
        <!-- VEHICULO AÑO-->
        <div v-if="isFieldVisible('car_year')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="car_year" class="form-label text-left">{{ getFieldDescription('car_year') }}</label>
            <SelectYears 
                :car_year="formData.car_year"
                v-bind:selectedYear="selectedYears" 
                v-on:update:selectedYear="selectedYears = $event"
                @change="emitFieldChanged('car_year')"
                required="required"
              >
            </SelectYears>
          </div>
        </div>
        <!-- VEHICULO MOTOR -->
        <div v-if="isFieldVisible('car_engine')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="car_engine" class="form-label text-left">{{ getFieldDescription('car_engine') }}</label>
            <input
              type="text"
              class="form-control"
              name="car_engine"
              v-model="formData.car_engine"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('car_engine')"
            />
          </div>
        </div>
        <!-- VEHICULO VIN -->
        <div v-if="isFieldVisible('car_vin')" class="col-md-3 mt-3">
            <div class="form-group bordered">
              <label for="car_vin" class="form-label text-left">{{ getFieldDescription('car_vin') }}</label>
              <input
                type="text"
                class="form-control"
                name="car_vin"
                v-model="formData.car_vin"
                required="required"
                maxlength="191"
                @input="() => emitFieldChanged('car_vin')"
              />
            </div>
        </div>
        <!-- VEHICULO DOMINIO -->
        <div v-if="isFieldVisible('car_domain')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="car_domain" class="form-label text-left">{{ getFieldDescription('car_domain') }}</label>
            <input
              type="text"
              class="form-control"
              name="car_domain"
              v-model="formData.car_domain"
              required="required"
              maxlength="10"
              @input="() => emitFieldChanged('car_domain')"
            />
          </div>
        </div>
        <!-- VEHICULO KILOMETROS -->
        <div v-if="isFieldVisible('car_kilometers')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="car_kilometers" class="form-label text-left">{{ getFieldDescription('car_kilometers') }}</label>
            <input
              type="text"
              class="form-control"
              name="car_kilometers"
              v-model="formData.car_kilometers"
              required="required"
              maxlength="10"
              @input="() => emitFieldChanged('car_kilometers')"
            />
          </div>
        </div>
        <!-- VEHICULO COLOR -->
        <div v-if="isFieldVisible('car_color')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="car_color" class="form-label text-left">{{ getFieldDescription('car_color') }}</label>
            <input
              type="text"
              class="form-control"
              name="car_color"
              v-model="formData.car_color"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('car_color')"
            />
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, watch, watchEffect } from 'vue'
  import SelectCarsTypes from './selectDatos/SelectCarsTypes'
  import SelectCarsModels from './selectDatos/SelectCarsModels'
  import SelectCarsBrands from './selectDatos/SelectCarsBrands'
  import SelectYears from './selectDatos/SelectYears'
  import apiCars from '../../../apis/Cars'
  import {
    selectTypesCars,
    //selectModelsCars,
    selectBrandsCars,
  } from '../../../Utils/apiCarsSelectorHelpers'

  export default {
    name: 'FormVehicleCars',
    props: {
      data: Object,
    },
    components: {
      SelectCarsTypes,
      SelectCarsModels,
      SelectCarsBrands,
      SelectYears,
    },
    emits: ['formDataChanged'],
    setup(props, { emit }) {
      const dataCompany = ref(props.data.dataCompaniesForms);
      const dataFormsField = ref(props.data.dataFormsField);
      const showComponentData = ref(false);
      const carType = ref([]);
      const carBrand = ref([]);
      const carMdel = ref([]);
      const selectedYears = ref('');
      const selectedTypesCars = ref('');
      const selectedModelsCars = ref('');
      const selectedBrandsCars = ref('');
      const estimatedCarKm = ref('');

      const formData = ref({
        car_engine: null,
        car_vin: null,
        car_domain: null,
        car_kilometers: null,
        car_color: null,
      });
 
      const cargarDatos = async () => {
        try {
          showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.car_type_id ||
            dataCompany.value.car_year ||
            dataCompany.value.car_engine ||
            dataCompany.value.car_vin ||
            dataCompany.value.car_domain ||
            dataCompany.value.car_kilometers ||
            dataCompany.value.car_color)
        );
          carType.value = await selectTypesCars();
          carBrand.value = await selectBrandsCars();
        } catch (error) {
          console.error(error);
        }
      };

      const isFieldVisible = (fieldName) => {
        return dataCompany.value && dataCompany.value[fieldName] === 1;
      };

      const getFieldDescription = (fieldNameLabel) => {
        let description = fieldNameLabel;
        const dataFormsFieldsWithData = Object.values(dataFormsField.value);
  
        dataFormsFieldsWithData[0].forEach((entry) => {
          const field = entry;
  
          if (field.name === fieldNameLabel) {
            description = field.description;
          }
        });
        return description;
      };

      const getModels = async (newBrands) => {
        try {
          const carBrandId = {
            carBrandId: newBrands,
          };
          const response = await apiCars.postCarsModels(carBrandId);
          carMdel.value = response.data;
        } catch (error) {
          console.error(error);
        }
      };

      const emitFieldChanged = () => {
        if (formData.value.car_kilometers) {
          let value = formData.value.car_kilometers;
          value = value.replace(/\./g, '');
          value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          estimatedCarKm.value = value;
          formData.value.car_kilometers = `${estimatedCarKm.value}`;
        }
        formData.value.car_type_id = selectedTypesCars.value || null;
        formData.value.car_brand_id = selectedBrandsCars.value || null;
        formData.value.car_model_id = selectedModelsCars.value || null;
        formData.value.car_year = selectedYears.value || null,

        emit('formDataChanged',  formData.value);
      };

      watch(selectedBrandsCars, (newBrands) => {
        getModels(newBrands);
      });


      watchEffect(() => {
        if (showComponentData.value) {
          if (selectedModelsCars.value !== formData.value.car_model_id) {
            emitFieldChanged();
          }
        }
      });

      onMounted(cargarDatos);

      return {
        dataCompany,
        dataFormsField,
        showComponentData,
        carType,
        carBrand,
        carMdel,
        selectedYears,
        selectedTypesCars,
        selectedModelsCars,
        selectedBrandsCars,
        getFieldDescription,
        getModels,
        formData,
        isFieldVisible,
        emitFieldChanged,
        estimatedCarKm,
      };
    },
  };
</script>
